import {VIEW_IDS, VIEW_ICONS, VIEW_NAMES} from '@github-ui/issue-url-helper/constants/view-constants'
import type {SidebarLink} from '@github-ui/saved-views'

export const repoSidebarLinks: SidebarLink[] = [
  {
    id: VIEW_IDS.repository,
    name: VIEW_NAMES.repository,
    searchType: 'issues',
    query: 'is:issue state:open',
    icon: VIEW_ICONS.repository,
    color: 'gray',
    source: 'predefined',
  },
  {
    id: VIEW_IDS.assignedToMe,
    name: VIEW_NAMES.assignedToMe,
    searchType: 'issues',
    query: 'is:issue state:open assignee:@me',
    icon: VIEW_ICONS.assignedToMe,
    color: 'gray',
    source: 'predefined',
  },
  {
    id: VIEW_IDS.created,
    name: VIEW_NAMES.created,
    searchType: 'issues',
    query: 'is:issue state:open author:@me',
    icon: VIEW_ICONS.created,
    color: 'gray',
    source: 'predefined',
  },
  {
    id: VIEW_IDS.mentioned,
    name: VIEW_NAMES.mentioned,
    searchType: 'issues',
    query: 'is:issue state:open mentions:@me',
    icon: VIEW_ICONS.mentioned,
    color: 'gray',
    source: 'predefined',
  },
  {
    id: VIEW_IDS.recent,
    name: VIEW_NAMES.recent,
    searchType: 'issues',
    query: 'is:issue updated:>@today-1w sort:updated-desc',
    icon: VIEW_ICONS.recent,
    color: 'gray',
    source: 'predefined',
  },
]
